<script setup lang="ts">
import NewsDetailPage from '../news/[slug].vue'

definePageMeta({
  hideDefaultTopNav: true,
})
</script>

<template>
  <NewsDetailPage />
</template>
